import { useQuery } from '@tanstack/react-query';
import { ApiClient } from 'lib/api/client';
import { QUERY_KEYS } from 'settings/config';
import { useApiReady } from './use-api-ready';

/** Get the list of available subscription plans */
export function useSubscriptionPlans({ enabled = true } = {}) {
  const apiReady = useApiReady();

  return useQuery(
    [QUERY_KEYS.subscriptions],
    () => new ApiClient().subscriptionPlanApi.orgSubscriptionList(),
    {
      select: (data) => data.data,
      enabled: apiReady && enabled,
    }
  );
}
